import type { ContentRefKind } from '@gitbook/app-content-refs';

/**
 * Content refreferences that are allowed to be inserted into an inline mention.
 */
export const ALLOWED_CONTENT_REFS_IN_INLINE_MENTION: ContentRefKind[] = [
    'anchor',
    'page',
    'space',
    'url',
    'file',
    'user',
];
